import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import { MdDateRange } from 'react-icons/md';
import { timezones } from './timezones';
import iconImg1 from '../../../assets/icon-arrow-magic.svg';
import iconImg2 from '../../../assets/icon-calendar.svg';
import iconImg3 from '../../../assets/person-avatar.svg';
import { QuickTtips, StyledSheduleCampaign } from './CreateCompaign.styles';
import { useLocation } from 'react-router-dom';

const Step7 = ({
  setData,
  data,
  NextStep,
  submit,
  goBack,
  step,
  setStep,
  totalStep = 7,
  type,
  isEdit,
  onStep7DataChange,
}) => {
  const [form] = useForm();
  const location = useLocation();
  const campaignStatus = location?.state?.status;
  const campaignId = location?.state?.campaign_id;
  const [scheduleSettingsData, setScheduleSettingsData] = useState();
  const [loading, setLaoding] = useState(false);
  const [selectDate, setSelectDate] = useState();
  const [timePeriodtab, setTimePeriodtab] = useState('am');
  const [endTimePeriodtab, setEndTimePeriodtab] = useState('pm');

  const convertTo24Hour = (hour, period) => {
    if (!hour) return null;
    let h = parseInt(hour, 10);

    if (period === 'am') {
      if (h === 12) h = 0;
    } else if (period === 'pm') {
      if (h !== 12) h += 12;
    }

    return `${h.toString().padStart(2, '0')}:00`;
  };
  const handleSubmit = async e => {
    try {
      setLaoding(true);
      const dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      };

      const startHour = convertTo24Hour(e.startHour?.value, timePeriodtab);
      const endHourHour = convertTo24Hour(e.endHour?.value, endTimePeriodtab);

      const selectedDays = Object.keys(dayMap)
        .filter(day => e[day])
        .map(day => dayMap[day]);
      // Validate before persisting — otherwise an empty-days schedule is POSTed first
      // and the user sees an error even though the campaign was already mutated.
      if (selectedDays.length === 0) {
        Toast({ type: 'error', message: 'Please select at least one day.' });
        return;
      }
      const payload = {
        id: data?.step2?.campaignId || data?.step6?.campaignId || data?.campaignId || campaignId,
        changes: {
          scheduler_cron_value: {
            tz: e.tz.value,
            startHour: startHour,
            endHour: endHourHour,
            days: selectedDays,
          },
          // min_time_btwn_emails: Number(e.minutes),
          // schedule_start_time: selectDate,
          // Ensure this is always a valid number (avoid NaN downstream)
          max_leads_per_day: Number(e?.daily_limit ?? 0),
        },
      };
      const res = await campaignService.scheduleSettingCampaign(payload);
      if (res?.success) {
        Toast({ type: 'success', message: res.message });
        setData(prev => ({ ...prev, step7: payload }));
        setStep(8);
      } else {
        Toast({ type: 'error', message: res?.message || 'Failed to save schedule. Please try again.' });
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    } finally {
      setLaoding(false);
    }
  };
  useEffect(() => {
    if (isEdit) {
      const getScheduleSettings = async () => {
        try {
          const res = await campaignService.getCampaignScheduleSettings(campaignId);
          setScheduleSettingsData(res.data || null);
        } catch (err) {
          Toast({ type: 'error', message: err.message });
          setScheduleSettingsData(null);
        }
      };
      getScheduleSettings();
    }
  }, [campaignId, isEdit]);

  useEffect(() => {
    if (isEdit && scheduleSettingsData) {
      const selectedTz = timezones?.find(tz => tz.value === scheduleSettingsData?.timezone);

      const dayKeys = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      const daysObj = dayKeys?.reduce((acc, key) => ({ ...acc, [key]: false }), {});

      (scheduleSettingsData?.daysOfWeek || []).forEach(day => {
        const key = day.toLowerCase();
        if (key in daysObj) {
          daysObj[key] = true;
        }
      });

      const parseHour = timeStr => {
        if (!timeStr) return null;
        let [h] = timeStr.split(':');
        h = parseInt(h, 10);

        let period = 'am';
        let hourVal = h;

        if (h === 0) {
          hourVal = 12; // midnight
          period = 'am';
        } else if (h === 12) {
          hourVal = 12;
          period = 'pm';
        } else if (h > 12) {
          hourVal = h - 12;
          period = 'pm';
        } else {
          period = 'am';
        }

        return {
          option: { label: hourVal, value: hourVal },
          period,
        };
      };

      const startParsed = parseHour(scheduleSettingsData?.startHour);
      const endParsed = parseHour(scheduleSettingsData?.endHour);

      if (startParsed) setTimePeriodtab(startParsed.period);
      if (endParsed) setEndTimePeriodtab(endParsed.period);

      form.setFieldsValue({
        tz: selectedTz,
        startHour: startParsed?.option,
        endHour: endParsed?.option,
        daily_limit: scheduleSettingsData?.dailyLimit ?? '',
        ...daysObj,
      });
    }
  }, [isEdit, scheduleSettingsData]);

  const hours = [
    {
      label: 1,
      value: 1,
    },
    {
      label: 2,
      value: 2,
    },
    {
      label: 3,
      value: 3,
    },
    {
      label: 4,
      value: 4,
    },
    {
      label: 5,
      value: 5,
    },
    {
      label: 6,
      value: 6,
    },
    {
      label: 7,
      value: 7,
    },
    {
      label: 8,
      value: 8,
    },
    {
      label: 9,
      value: 9,
    },
    {
      label: 10,
      value: 10,
    },
    {
      label: 11,
      value: 11,
    },
    {
      label: 12,
      value: 12,
    },
  ];

  const tipData = [
    {
      img: iconImg1,
      title: 'Sending Limits',
      description: 'Keep your daily sending volume between 20–50 emails per inbox.',
    },
    {
      img: iconImg3,
      title: 'Email Health',
      description: 'Staying within healthy limits protects your domain reputation and improves deliverability.',
    },
    {
      img: iconImg1,
      title: 'Warm Up Before You Scale',
      description: 'Let Houdiny warm up your inboxes first. A warmed inbox lands in primary inboxes, not spam.',
    },
    {
      img: iconImg2,
      title: 'Use Houdiny’s Unlimited Mailboxes',
      description:
        'Connect as many mailboxes as you want. More inboxes = more volume per day with almost zero deliverability risk.',
    },
  ];

  return (
    <StyledSheduleCampaign>
      <Form className="form-area" form={form} onSubmit={e => handleSubmit(e)}>
        <div className="column-wrap">
          <div className="left-col">
            <div className="head">
              <div>
                <span className="heading">Schedule Campaign!</span>
                <p>Name your campaign and select where your leads will come from.</p>
              </div>
            </div>
            <div className="timezone-select">
              <Form.Item
                colorBg
                selectSm
                label="Time Zone"
                type="select"
                rounded
                name="tz"
                disabled={campaignStatus === 'completed'}
                placeholder="Select Time Zone"
                rules={[
                  {
                    required: true,
                    message: 'Time Zone is required',
                  },
                ]}
                options={timezones}>
                <Field />
              </Form.Item>
            </div>
            <div className="choose-time-fields">
              <Form.Item
                label="From"
                type="select"
                name="startHour"
                selectSm
                disabled={campaignStatus === 'completed'}
                options={hours}
                suffix={
                  <div className="time-period">
                    <button
                      type="button"
                      className={timePeriodtab === 'am' && 'active'}
                      onClick={() => setTimePeriodtab('am')}>
                      AM
                    </button>
                    <button
                      type="button"
                      className={timePeriodtab === 'pm' && 'active'}
                      onClick={() => setTimePeriodtab('pm')}>
                      PM
                    </button>
                  </div>
                }
                rules={[
                  {
                    required: true,
                    message: 'Start Hour is required',
                  },
                ]}>
                <Field />
              </Form.Item>
              <Form.Item
                type="select"
                label="To"
                name="endHour"
                options={hours}
                disabled={campaignStatus === 'completed'}
                selectSm
                suffix={
                  <div className="time-period">
                    <button
                      type="button"
                      className={endTimePeriodtab === 'am' && 'active'}
                      onClick={() => setEndTimePeriodtab('am')}>
                      AM
                    </button>
                    <button
                      type="button"
                      className={endTimePeriodtab === 'pm' && 'active'}
                      onClick={() => setEndTimePeriodtab('pm')}>
                      PM
                    </button>
                  </div>
                }
                rules={[
                  {
                    required: true,
                    message: 'End Hour is required',
                  },
                ]}>
                <Field />
              </Form.Item>
            </div>

            <span className="days-list-label">Days:</span>
            {/* // checkbox */}
            <div className="days-list">
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="monday"
                label="Monday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="tuesday"
                label="Tuesday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="wednesday"
                label="Wednesday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="thursday"
                label="Thursday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="friday"
                label="Friday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="saturday"
                label="Saturday">
                <Field />
              </Form.Item>
              <Form.Item
                disabled={campaignStatus === 'completed'}
                noMargin
                type="checkbox"
                rounded
                name="sunday"
                label="Sunday">
                <Field />
              </Form.Item>
            </div>
            <div className="choose-time-fields">
              <div className="daily-limit-field">
                <Form.Item
                  colorBg
                  inputSm
                  label="Daily limit per email"
                  placeholder="Enter daily limit"
                  type="number"
                  step={1}
                  disabled={campaignStatus === 'completed'}
                  name="daily_limit"
                  rules={[
                    {
                      required: true,
                      message: 'Daily limit are required',
                    },
                    {
                      transform: value => {
                        if (value === '' || value === null || value === undefined) return false;
                        const num = Number(value);
                        if (Number.isNaN(num) || num < 1 || num > 200 || !Number.isInteger(num)) {
                          return true;
                        }
                        return false;
                      },
                      message: "Daily limit must be between 1 and 200 and don't enter values in points (e.g. 1.5)",
                    },
                  ]}>
                  <Field />
                </Form.Item>
              </div>
              {/* <Form.Item>
                <Field
                  className="date"
                  colorBg
                  label="Start Date"
                  type="datepicker"
                  rounded
                  name="start_date"
                  placeholder="DD/MM/YYYY"
                  selected={selectDate}
                  suffix={<MdDateRange />}
                  onChange={({ target: { value } }) => {
                    setSelectDate(value);
                  }}
                />
              </Form.Item> */}
            </div>
          </div>
          <div className="right-col">
            <QuickTtips>
              <div className="head">
                <strong className="title">Quick Tips</strong>
                <p>Here are some pointers to help you set up your campaign smoothly:</p>
              </div>
              <ul className="tip-list">
                {tipData.map((item, index) => (
                  <li key={index}>
                    <div className="icon-box">
                      <img src={item.img} alt="img" />
                    </div>
                    <div className="text-box">
                      <strong className="title">{item.title}</strong>
                      <p>{item.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </QuickTtips>
          </div>
        </div>
        <div className="btn-holder">
          {/* <Button className="editMode" newStyle rounded variant="outline" width="155px" onClick={() => setStep(7)}>
            Back
          </Button> */}

          {/* <div className="btn-wrap editMode"> */}
          {/* <Button newStyle rounded variant="underline" width="155px">
              Save Draft
            </Button> */}
          {campaignStatus !== 'completed' && (
            <Button newStyle rounded variant="darkBlue" width="155px" type="submit" loader={loading} disabled={loading}>
              {isEdit ? 'Save' : 'Next'}
            </Button>
          )}
          {/* </div> */}
        </div>
      </Form>
    </StyledSheduleCampaign>
  );
};

export default Step7;
